import { jsx as s } from "react/jsx-runtime";
function l(c) {
  return /* @__PURE__ */ s("svg", { id: "Layer_1", version: "1.1", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...c, children: /* @__PURE__ */ s(
    "path",
    {
      d: "M12.98,3.93c-1.84-.55-3.71.12-4.78,1.71l-.2.3h0s-1.37,2.05-1.37,2.05c0,0,0,0,0,0h0s-.73,1.1-.73,1.1c-.6.9-1.53,1-2.21.79-.68-.2-1.4-.81-1.4-1.89s.72-1.68,1.4-1.89c.19-.06.39-.09.6-.09.56,0,1.17.23,1.61.88l.27.4,1.36-2.04c-1.09-1.33-2.81-1.86-4.5-1.35-1.84.56-3.02,2.16-3.02,4.07s1.19,3.52,3.02,4.07c1.84.56,3.71-.12,4.78-1.71l.2-.3,1.37-2.06.73-1.09c.6-.9,1.53-1,2.21-.79.68.2,1.4.81,1.4,1.89s-.72,1.68-1.4,1.89c-.67.21-1.61.1-2.21-.79l-.27-.41-1.36,2.04c.82,1,1.98,1.54,3.23,1.54.42,0,.85-.06,1.28-.19,1.84-.56,3.02-2.16,3.02-4.07s-1.19-3.52-3.02-4.08Z",
      fill: "#fff"
    }
  ) });
}
export {
  l as default
};
